<template>
  <v-layout>
    <v-flex xs12 md5>
      <v-card style="height: 550px; overflow-y: auto;">
        <v-card-text>
          <listOption
            :items.sync="comp_optionList"
            @searchText="searchText"
            @update_item="update_item"
            @update_all="update_all"
            @clear_search="clear_search"
          />
        </v-card-text>
      </v-card>
    </v-flex>

    <v-flex xs12 md7>
      <v-card style="height: 550px; overflow-y: auto;">
        <v-card-text>
          <div style="padding: 8px;">Total {{ show_List.length }} selected</div>
          <ListShow
            :items.sync="comp_showList"
            @delete_item="delete_item"
            @update_role="update_role"
          />
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import ListOption from "./ListOption";
import ListShow from "./ListShow";
import common from "../functions/general";
import qb from "../functions/query.builder";

export default {
  name: "ListGroup_Collaborator",
  props: {
    showItems: {
      type: Array,
      required: true
    },
    showItemsProp: {
      type: Array,
      required: true
    }
  },
  components: {
    ListOption: ListOption,
    ListShow: ListShow
  },
  data () {
    return {
      option_List: [],
      show_List: [],
      option_ListCache: [],
      memberGlobal_id: ""
    };
  },
  watch: {
    "showItems": {
      handler: function() {
        // this.show_List = [...this.showItems];
        this.show_List = structuredClone(this.showItems);
      },
      deep: true
    }
  },
  methods: {
    searchText (text) {
      let propertiesToSearch = ["emp__full_name", "emp__user__username", "dept__name", "dept__company__name"]
      let temp = this.option_ListCache.filter(item =>
        propertiesToSearch.some(prop =>
          item[prop] && item[prop].toLowerCase().includes(text.toLowerCase())
        )
      )
      this.option_List = temp;
    },
    clear_search () {
      this.option_List = this.option_ListCache;
    },
    get_arrIndex(arr, targetID) {
      // if (arr != undefined) {
      //   return arr.findIndex(obj => obj["id"] === targetID);
      // }
      return arr.findIndex(obj => obj["id"] === targetID);
    },
    mapObj(obj, objTarget) {
      var temp = obj.map(item=>{
        item["isSelected"] = false;
        
        if(objTarget != undefined){
          var found = objTarget.find(el=> el["id"]==item["id"]);
          if(found){
           item["isSelected"] = true;
          }
        }
        return item;
      });

      return temp;
    },
    checkMember_bln (item) {
      let found1 = this.comp_showList.find(e => e.id == item.id);
      return this.checkMember_val(found1.prop);
    },
    checkMember_val (role) {
      return role.filter(e => e.g_role_id==this.memberGlobal_id)[0].value;
    },
    delete_item (idx) {
      if (this.checkMember_val(this.show_List[idx].prop)) {
        common.wMsgBox.Error("Unable to remove 'Member' from list.");
      } else {
        this.show_List.splice(idx,1);
      }
      this.$emit("newList", this.show_List);
    },
    update_role ({idx, role, role_idx}) {
      if (role.g_role_id!=this.memberGlobal_id) {
        let tempRoleVal = structuredClone(!role.value);
        this.show_List[idx].prop[role_idx].value = tempRoleVal;
      }
      this.$emit("newList", this.show_List);
    },
    update_item (item) {
      if (item.isSelected) {
        // delete member from list, if not 'member'
        if (this.checkMember_bln(item)) {
          common.wMsgBox.Error("Unable to remove 'Member' from list.");
        } else {
          let idx1 = this.get_arrIndex(this.show_List, item.id);
          this.show_List.splice(idx1, 1);
        }
      } else {
        // add member to list
        this.show_List.push({
          comp: item.dept__company__name,
          dept: item.dept__name,
          id: item.id,
          name: item.emp__full_name,
          // prop: this.show_List_prop,
          prop: structuredClone(this.showItemsProp),
          username: item.emp__user__username,
        });
      }
      this.$emit("newList", this.show_List);
    },
    update_all(bln) {
      let lenK = this.option_List.length;
      for (let m = 0; m < lenK; m++) {
        var found = this.show_List.find(el=> el.id == this.option_List[m].id);

        if (bln) {
          if (found == undefined) {
            let temp2 = {};
            temp2["username"] = this.option_List[m]["emp__user__username"];
			  	  temp2["name"] = this.option_List[m]["emp__full_name"];
            // temp2["prop"] = this.show_List_prop;
            temp2["prop"] = structuredClone(this.showItemsProp);
			  	  temp2["id"] = this.option_List[m]["id"];
			  	  temp2["comp"] = this.option_List[m]["dept__company__name"];
			  	  temp2["dept"] = this.option_List[m]["dept__name"];
          
            this.show_List.push(temp2);
          }
        } else {
          if (found) {
            if (!this.checkMember_bln(found)) {
              // common.wMsgBox.Error("Unable to remove 'Member' from list.");
              let idx2 = this.get_arrIndex(this.show_List, this.option_List[m].id);
              this.show_List.splice(idx2,1);
            }
          }
        }
      }
      this.$emit("newList", this.show_List);
    }
  },
  async mounted () {
    this.memberGlobal_id = common.Setting.getEventsMemberGlobalID();

		let cls_qb = new qb.QueryBuilder();
		cls_qb.Method = "all";
		cls_qb.Table = "emps_dept_employee";
		cls_qb.Select = [
			"id",
			"emp__user__username",
			"emp__full_name",
			"dept__name",
			"dept__company__name",
			"emp__user__email",
			"emp__email_p"
		];
		// var rule = new qb.Rule();
		// rule
		// 	.field("parent_company_id__name")
		// 	.operator(qb.STR_OPERATOR.I_CONTAINS)
		// 	.value("group");
		// cls_qb.addRule(rule);
    cls_qb.Order = ["emp__full_name"];
    var result = await common.wBackEndComm.PostData("process_qb/", cls_qb);
    if (result.data.Status == 1) {
      this.option_List = result.data.Body.records.map(item => {
        item["isSelected"] = false;
        return item;
      });
      this.option_ListCache = [...this.option_List];
    } else {
      common.wMsgBox.Error(result.data.Description);
    }
  },
  computed: {
    comp_optionList: {
      get: function () {
        return this.mapObj(this.option_List, this.comp_showList);
        // return this.this.option_List;
      },
      set:function(val){
        
      }
    },
    comp_showList: {
      get: function () {
        // return this.showItems;
        return this.show_List;
      },
      set:function(val){
        // this.$emit("input",val);
      }
    }
  }
};
</script>
